<!--  -->
<template>
  <div>
<section class="page-banner" style="background-image: url(/static/images/banner.jpg);">
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <h2 class="banner-title">直播中心</h2>
                  <div class="bread-crumbs">
                      <router-link to="/">首页</router-link> <span></span> 直播中心
                  </div>
              </div>
          </div>
      </div>
  </section>  
  <!-- Banner End -->

  <!-- Blog Start -->
  <section class="blogpage-section">
      <div class="container">
          <div class="row">
              <div class="col-lg-8 col-md-7">
                  <div class="row">
                      <div class="col-lg-6" v-for="(live,index) in lives" :key="index">
                          <div class="post-item-1"  @click="$router.push(`/mylive/${live._id}`)">
                              <img  :src="`${global.remoteIp}/uploads/${live.picsrc}`"  alt="">
                              <div class="b-post-details">
                                  <div class="bp-meta">
                                      <a><i class="icon_clock_alt"></i>{{dateFormat(new Date(live.time),"yyyy-MM-dd hh:mm")}}</a>
                                      <a><i class="icon_chat_alt"></i>{{live.teacher}}</a>
                                  </div>
                                  <h3><a>{{live.title}}</a></h3>
                                  <a class="read-more">{{live.state=='1'?'正在直播':'暂未开播'}}<i v-if="live.state=='1'" class="arrow_right"></i></a>
                              </div>
                          </div>
                      </div>
                    
                  </div>
                  <div class="row">
                      <div class="col-lg-12">
                          <div class="bisylms-pagination">
                              <el-pagination
                              background
                              :page-size="6"
                              :hide-on-single-page="intTotal<=6"
                              layout="prev, pager, next"
                              @current-change="toPage"
                              @prev-click="toPage"
                              @next-click="toPage"
                              :total="intTotal">
                              </el-pagination>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4 col-md-5">
                  <div class="blog-sidebar">
                      <aside class="widget widget-search">
                          <div class="search-form" action="#" method="post">
                              <input type="search"  v-model="searchWords" placeholder="搜索直播...">
                              <button type="submit"  @click="toPage(1)"><i class="ti-search"></i></button>
                          </div>
                      </aside>
                      <aside class="widget widget-categories">
                          <h3 class="widget-title">直播科目</h3>
                          <ul>
                            <el-select v-model="searchType" filterable placeholder="请选择">
                              <el-option
                                v-for="courcate in courcates"
                                :key="courcate.name"
                                :label="courcate.name"
                                :value="courcate.name">
                              </el-option>
                            </el-select>
                          </ul>
                      </aside>
                    
                  </div>
              </div>
          </div>
      </div>
  </section>
  <!-- Blog End -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      lives: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    let strsearchWords = this.$route.query.searchWords;
    if(strsearchWords)
    {
      strsearchWords = "&title=$regex:" + strsearchWords;
    }
    else{
      strsearchWords="";
    }
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt"+strsearchWords)
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=state";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/livings?page=${
            this.intCurrent
          }&limit=6${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.lives = res.data.data;
       //     this.toTop();
          }
        });
    },
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
::v-deep .el-pager li.active {
  color: #51be78;
}

 .buytip-labelwkb {
  background-color: #a7a2a2;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 4px 4px 4px 0;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 58px;
  z-index: 1;
}

 .buytip-labelwkb:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  right: 6px;
  z-index: -1;
  background-color: #a7a2a2;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skewX(351deg);
  -moz-transform: skewX(351deg);
  -ms-transform: skewX(351deg);
  -o-transform: skewX(351deg);
  transform: skewX(351deg);
  -webkit-border-radius: 4px 0 0 0;
  -moz-border-radius: 4px 0 0 0;
  border-radius: 4px 0 0 0;
}
a:not([href]):not([tabindex]) {
    color: initial !important;
}
</style>
